var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('side-menu'),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('page-content',{nativeOn:{"click":function($event){return _vm.toggleNavbars.apply(null, arguments)}}}),_vm._v(" "),_c('content-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }